// GENERATED by tools/extract/protocol.ts — do not edit.
//
// The SPA <-> extension contract, reconciled from both upstreams (plan §1.7).
//
// Deliberately NO upstream sha in this header. `emitText` compares this file
// byte-for-byte, so a volatile provenance line would make `pnpm check:generated` report
// it stale on every unrelated upstream commit — the same false alarm the JSON emitter
// avoids by excluding `meta`. Provenance lives in protocol.json under meta.upstream.
//
// Members marked spa-only / shell-only carry an authority decision in
// packages/protocol/authority.json. Const objects rather than TS enums so the values
// survive `isolatedModules` and erasable-syntax builds unchanged.

/** IFrameEventType — postMessage. */
export const IFrameEventType = {
  AlertEntityNotificationFound: "alertEntityNotificationFound",
  AlertEntityNotificationLoading: "alertEntityNotificationLoading",
  AlertEntityNotificationNotFound: "alertEntityNotificationNotFound",
  AlertEntityNotificationReset: "alertEntityNotificationReset",
  AssignToJob: "assignToJob",
  CandidateNotificationFound: "candidateNotificationFound",
  CandidateNotificationLoading: "candidateNotificationLoading",
  CandidateNotificationNotFound: "candidateNotificationNotFound",
  CandidateNotificationReset: "candidateNotificationReset",
  CloseDialog: "closeDialog",
  ConditionalOpenShortlistOnInit: "conditionalOpenShortlistOnInit",
  GetExtensionId: "getExtensionId",
  GetExtensionIdResponse: "getExtensionIdResponse",
  GetExtensionVersion: "getExtensionVersion",
  GetExtensionVersionResponse: "getExtensionVersionResponse",
  GetIsAdmin: "getIsAdmin",
  GetIsAdminResponse: "getIsAdminResponse",
  GetRequiredPermissionsGranted: "getRequiredPermissionsGranted",
  GetRequiredPermissionsGrantedResponse: "getRequiredPermissionsGrantedResponse",
  GetSavedUserEmail: "getSavedUserEmail",
  GetSavedUserEmailResponse: "getSavedUserEmailResponse",
  GetShortListDefaultHandleLocation: "getShortListDefaultHandleLocation",
  GetShortListDefaultHandleLocationResponse: "getShortListDefaultHandleLocationResponse",
  GetShortListHandleLocation: "getShortListHandleLocation",
  GetShortListHandleLocationResponse: "getShortListHandleLocationResponse",
  GetShortListViewProperties: "getShortListViewProperties",
  GetShortListViewPropertiesResponse: "getShortListViewPropertiesResponse",
  GetShortlistOpenedOrClosed: "getShortlistOpenedOrClosed",
  GetShortlistOpenedOrClosedResponse: "getShortlistOpenedOrClosedResponse",
  GetShortlistSessionHostInfo: "getShortlistSessionHostInfo",
  GetShortlistSessionHostInfoResponse: "getShortlistSessionHostInfoResponse",
  HostMouseMove: "hostMouseMove",
  HostPageChange: "hostPageChange",
  HostPageHtml: "hostPageHtml",
  HostPageTrack: "hostPageTrack",
  HostSearchLoadingNotification: "hostSearchLoadingNotification",
  HostSearchResultsFoundNotification: "hostSearchResultsFoundNotification",
  HostSearchResultsNotFound: "hostSearchResultsNotFound",
  LoadPage: "loadPage",
  OAuthStateChange: "oAuthStateChange", // shell-only
  OpenCandidatePage: "openCandidatePage",
  OpenEntityPage: "openEntityPage",
  OpenHotlist: "openHotlist",
  OpenShortlist: "openShortlist",
  PageLoaded: "pageLoaded",
  Ready: "ready",
  ReloadPage: "reloadPage",
  ReloadTopPage: "reloadTopPage", // shell-only
  RequestPermissions: "requestPermissions",
  RequestPermissionsResponse: "requestPermissionsResponse",
  SetAlertsCount: "setAlertsCount",
  SetExtensionPinnedMode: "setExtensionPinnedMode",
  SetLastViewedAlerts: "setLastViewedAlerts",
  SetNewCandidatesIndication: "setNewCandidatesIndication",
  SetShortlistPinnedMode: "setShortlistPinnedMode",
  SetViewModeHideTransitionDone: "setViewModeHideTransitionDone",
  SetViewModeStarted: "setViewModeStarted",
  ShortlistContainerStateChange: "shortlistContainerStateChange",
  ShortlistContainerStateChangeNotificationResponse: "shortlistContainerStateChangeNotificationResponse",
  ShortlistDragged: "shortlistDragged",
  ShortlistMouseEnter: "shortlistMouseEnter",
  ShortlistMouseLeave: "shortlistMouseLeave",
  ShortlistMouseMove: "shortlistMouseMove",
  ShortlistNotification: "shortlistNotification",
  ShortlistNotificationClick: "shortlistNotificationClick",
  ShortlistNotificationHandleClick: "shortlistNotificationHandleClick",
  ShortlistNotificationsHide: "shortlistNotificationsHide",
  ShortlistNotificationsShow: "shortlistNotificationsShow",
  ShortlistOpenedOrClosed: "shortlistOpenedOrClosed",
  SignIn: "signIn", // spa-only, @deprecated upstream
  SignOut: "signOut", // spa-only, @deprecated upstream
  SignUp: "signUp", // spa-only, @deprecated upstream
  SubFrameMouseMove: "subFrameMouseMove",
  UserAuthStateChange: "userAuthStateChange",
  UserVerified: "userVerified", // spa-only, @deprecated upstream
} as const
export type IFrameEventType = (typeof IFrameEventType)[keyof typeof IFrameEventType]

/** EntityType — postMessage. */
export const EntityType = {
  Candidate: 0,
  ClientContact: 1,
  Job: 2,
} as const
export type EntityType = (typeof EntityType)[keyof typeof EntityType]

/** ExternalMessageType — runtime.sendMessage. */
export const ExternalMessageType = {
  IsBackgroundSupportBroadcasting: "isBackgroundSupportBroadcasting",
  IsIFrameAuthEnabled: "isIFrameAuthEnabled",
  OpenPopup: "openPopup",
  UserAuthStateChange: "userAuthStateChange",
} as const
export type ExternalMessageType = (typeof ExternalMessageType)[keyof typeof ExternalMessageType]

/** BroadcastChannelTopic — BroadcastChannel. */
export const BroadcastChannelTopic = {
  AtsHostOpenEntityChannel: "atsHostOpenCandidateChannel", // spa-only
  AtsHostReplyToOpenCandidateChannel: "atsHostReplyToOpenCandidateChannel", // spa-only
  IFrameChannel: "iFrameChannel", // spa-only
  PostChannel: "postChannel", // spa-only
  SelectedAlertChannel: "selectedAlertChannel", // spa-only
} as const
export type BroadcastChannelTopic = (typeof BroadcastChannelTopic)[keyof typeof BroadcastChannelTopic]

/** FrameRole — shared-vocabulary. */
export const FrameRole = {
  Notifications: "notifications",
  Shortlist: "shortlist",
} as const
export type FrameRole = (typeof FrameRole)[keyof typeof FrameRole]

/** ExtensionViewWidth — shared-vocabulary. */
export const ExtensionViewWidth = {
  Detailed: 700,
  Extended: 378,
  Full: 1146,
  Slim: 200,
} as const
export type ExtensionViewWidth = (typeof ExtensionViewWidth)[keyof typeof ExtensionViewWidth]

/** ViewMode — shared-vocabulary. */
export const ViewMode = {
  FlexMode: 2,
  FullMode: 0,
  SlimMode: 1,
} as const
export type ViewMode = (typeof ViewMode)[keyof typeof ViewMode]

/** ShortListAttachTo — shared-vocabulary. */
export const ShortListAttachTo = {
  Left: "woo-attach-left",
  Right: "woo-attach-right",
} as const
export type ShortListAttachTo = (typeof ShortListAttachTo)[keyof typeof ShortListAttachTo]

/** ExtensionAlertContainerState — shared-vocabulary. */
export const ExtensionAlertContainerState = {
  EDIT: 1,
  VIEW: 0,
} as const
export type ExtensionAlertContainerState = (typeof ExtensionAlertContainerState)[keyof typeof ExtensionAlertContainerState]

/** ShortlistSessionHost — shared-vocabulary. */
export const ShortlistSessionHost = {
  ATS: 1,
  CVLibrary: 4,
  CWJobs: 17, // shell-only
  CareerBuilder: 7, // shell-only
  CareerJunction: 22, // shell-only
  CareerStructure: 11, // shell-only
  CaribbeanJobs: 23, // shell-only
  Caterer: 15, // shell-only
  CityJobs: 16, // shell-only
  Dice: 8, // shell-only
  EmedCareers: 18, // shell-only
  EstasContratado: 24, // shell-only
  Good: 33, // shell-only
  ICTJob: 25, // shell-only
  Indeed: 3,
  IrishJobs: 26, // shell-only
  JobServe: 9, // shell-only
  JobSite: 14, // shell-only
  Jobs: 27, // shell-only
  JustEngineers: 19, // shell-only
  Linkedin: 2,
  MilkRound: 20, // shell-only
  Monster: 5,
  MyJob: 28, // shell-only
  NIJobs: 29, // shell-only
  NextgenResumes: 12, // shell-only
  None: 0,
  PNet: 30, // shell-only
  Reed: 6,
  ResumeLibrary: 10, // shell-only
  RetailChoice: 21, // shell-only
  StepStone: 31, // shell-only
  TecoLoco: 32, // shell-only
  TotalJobs: 13, // shell-only
} as const
export type ShortlistSessionHost = (typeof ShortlistSessionHost)[keyof typeof ShortlistSessionHost]

/** UserAuthStateChangeEvent — shared-vocabulary. */
export const UserAuthStateChangeEvent = {
  OAuthSignIn: "OAuthSignIn",
  OAuthSignUp: "OAuthSignUp",
  PasswordReset: "PasswordReset",
  SignIn: "SignIn",
  SignOut: "SignOut",
  SignUp: "SignUp",
  UserMFAVerified: "UserMFAVerified",
  UserVerified: "UserVerified",
} as const
export type UserAuthStateChangeEvent = (typeof UserAuthStateChangeEvent)[keyof typeof UserAuthStateChangeEvent]

/** UserAuthStateChangeOrigin — shared-vocabulary. */
export const UserAuthStateChangeOrigin = {
  Context: "context",
  Popup: "popup",
} as const
export type UserAuthStateChangeOrigin = (typeof UserAuthStateChangeOrigin)[keyof typeof UserAuthStateChangeOrigin]

/** ExtensionOAuthProvider — shared-vocabulary. */
export const ExtensionOAuthProvider = {
  Google: "google",
  Microsoft: "microsoft",
} as const
export type ExtensionOAuthProvider = (typeof ExtensionOAuthProvider)[keyof typeof ExtensionOAuthProvider]
